import { Component } from '@angular/core';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';
import { ConfigService } from 'src/services/config.service';

@Component({
  selector: 'app-lsr-contact',
  templateUrl: './lsr_contact.component.html',
  styleUrls: ['./lsr_contact.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS]
})
export class LsrContactComponent {
  phoneContact: string;
  email: string;
  faxNumber: string;

  get telLink(): string {
    return `tel:${this.phoneContact || ''}`;
  }

  get mailtoLink(): string {
    return `mailto:${this.email || ''}`;
  }

  constructor(private configService: ConfigService) {
  }
  ngOnInit() {
    this.configService.isConfigLoaded().subscribe(loaded => {
      if (loaded) {
        let configModel = this.configService.getConfigModel();
        this.phoneContact = configModel.getConfigkeyname('Contact_Us_Phone');
        this.email = configModel.getConfigkeyname('Contact_Us_Email');
      }
    });
  }
}
